import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

const NavContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  ul {
    display: flex;
    flex-grow: 4;
    z-index: 5;
    align-items: center;
    justify-content: center;
    li {
      margin: 0 2vw;
      a {
        text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
        color: orange;
        font-size: calc(3px + 3vmin);
        border-bottom: 2px solid transparent;
        transition-duration: 0.5s;
        cursor: pointer;
        &:hover {
          border-bottom: 2px solid orange;
        }
      }
      .active {
        border-bottom: 2px solid orange;
      }
    }
  }
`;
const TransBackground = styled.div`
  display: flex;
  top: 0;
  position: absolute;
  width: 100%;
  height: 11vh;
  background-color: black;
  opacity: 0.5;
  z-index: 1;
`;

const NavBar = props => {
  const [activePage, setActivePage] = useState(0);
  const navList = [
    { text: "Start", index: 0 },
    // { text: "ToDo", index: 0 },
    // { text: "SL", index: 0 },
    { text: "Voice", index: 0 },
    // { text: "Translate", index: 0 }
  ];
  navList.map((value, index) => {
    return (value.index = index);
  });

  function navClick(index) {
    setActivePage(index);
    props.setPageNr(index);
  }
  return (
    <NavContainer>
      {/* <TransBackground></TransBackground> */}
      <ul>
        {navList.map((value, index) => {
          return (
            <li key={index}>
              <a
                href="#"
                className={activePage === value.index ? "active" : "inactive"}
                onClick={() => navClick(value.index)}
              >
                {value.text}
              </a>
            </li>
          );
        })}
      </ul>
    </NavContainer>
  );
};

export default NavBar;
